import React from "react";
import { Button, Modal, TableAdv } from "../../../../../../components";
import { mapTableRows } from "../../../../../../utils";
import { revisionHistoryrowdata } from "../../../../../../assets/data/candidatesData";

const ShowRevisionHistoryModal = ({ open, onClose }) => {
  const otherpaymentColumns = [
    { key: "PaymentType", label: "Payment Type" },
    { key: "TotalSalary", label: "Total Salary" },
    { key: "SalaryPerCycle", label: "Salary(Per Cycle)" },
    { key: "TotalBasePay", label: "Total Base Pay" },
    { key: "BasePayPerCycle", label: "Base Pay(Per Cycle)" },
    { key: "SalaryLessThanBasePay", label: "If Calculated Salary<Base Pay" },
    { key: "SalaryGreaterThanBasePay", label: "If Calculated Salary>Base Pay" },
    { key: "RevisePayCycle", label: "REVISE Pay Cycle" },
    { key: "DiemPaymentType", label: "Per Diem Payment Type" },
    { key: "NoOfCyclesRun", label: "No of Cycles Run" },
    { key: "CreatedOn", label: "Created On" },
  ];
  const tablerowData = revisionHistoryrowdata;
  const mappedRows = mapTableRows(tablerowData, otherpaymentColumns);
  return (
    <Modal isOpen={open} onClose={onClose} title="REVISION" width="max-w-6xl">
      <div className="mt-4">
        <TableAdv tableId={`employee_payments_payconfigurations_showrevisionhistorymodal`} columns={otherpaymentColumns} rows={mappedRows} hideToolBar />
      </div>
      <div className="flex justify-end mt-4 gap-x-2 mb-4">
        <Button title="Cancel" variant="outlined" onClick={() => onClose()} />
        <Button
          title="Save"
          variant="contained"
          color="primary"
          onClick={() => onClose()}
        />
      </div>
    </Modal>
  );
};

export default ShowRevisionHistoryModal;
